import { TranslationsContext } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Button, Container, Grid, GridColumn, Heading, Separator, Text } from 'telia-front-react';
import { useStores } from '../../stores/RootStore';

export interface NewsDetailsProps {
  title: string;
  displayDate: string;
  children: React.ReactNode;
}

const NewsDetailsContainer = observer((props: NewsDetailsProps): React.JSX.Element => {
  const { routeStore } = useStores();
  const { title, displayDate, children } = props;
  const { translate } = React.useContext(TranslationsContext);

  return (
    <Container>
      <Grid>
        <GridColumn width={['xs-12']}>
          <Text>
            <Grid align={['middle-xs']} noWrap={true}>
              <GridColumn width={['min']}>
                <Button icon="#arrow-left" text={translate('button.back')} variant="secondary" onClick={() => routeStore.push('/')} />
              </GridColumn>
              <GridColumn width={['max']}>
                <Heading level={1} className="h2">
                  {title}
                </Heading>
              </GridColumn>
            </Grid>
            <Separator spacing="medium" color="invisible" />
            <div className="text-small">
              <time dateTime={displayDate}>{displayDate}</time>
            </div>
            <Text>{children}</Text>
          </Text>
        </GridColumn>
      </Grid>
    </Container>
  );
});

export default NewsDetailsContainer;
